import { useEffect } from 'react';
import styled, { css, keyframes } from 'styled-components'

const Overlay = styled.div`
  width: 100%;
  height: 100dvh;
  min-height: 100dvh;
  position: fixed;
  bottom: 0;
  width: 100%;
  max-width: 600px;
  left: 50%;
  transform: translateX(-50%);
  background-color: rgba(0, 0, 0, 0.3); // 반투명 검정 배경
  z-index: 999; 
  display: flex;
  justify-content: center;
  align-items: center;
`
const slideUp = keyframes`
  0% {
    transform: translateY(100%);
  }
  100% {
    transform: translateY(0);
  }
`
const slideDown = keyframes`
  0% {
    transform: translateY(0);
  }
  100% {
    transform: translateY(100%);
  }
`
const BottomSheet = styled.div`
  position: fixed;
  height: ${({ height }) => height || '380px'};
  bottom: 0;
  width: 100%;
  min-width: 320px;
  max-width: 600px;
  margin: 0 auto;
  background-color: ${(props) => props.theme.colors.neutral[100]};
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
  animation: ${({ $isOpen }) => $isOpen ? css`${slideUp} 0.4s ease-in-out forwards` : css`${slideDown} 0.3s ease-in-out forwards`};
  z-index: 1000;
  padding: 20px;
  padding-bottom: env(safe-area-inset-bottom);
`

const BottomSheetLayout = ({ $isOpen, onClose, children, height }) => {
  // 바텀시트 내부 스와이프 시 body 움직임 방지
   useEffect(() => {
    if ($isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    // 예외적 상황을 위한 return문
    return () => {
      document.body.style.overflow = '';
    };
  }, [$isOpen]);

  return (
    <Overlay onClick={onClose}>
      <BottomSheet
        $isOpen={$isOpen}
        height={height}
        onClick={(e) => e.stopPropagation()}>
        {children}
      </BottomSheet>
    </Overlay>

  )
}

export default BottomSheetLayout
